import { moduleApi } from "@amtana/module";

import type { PurgeResult, Usage } from "./settings.schemas.ts";

type ForUser = { readonly userId: string; readonly organizationId: string };

export interface SettingsApi {
  usage(input: ForUser): Promise<Usage>;
  /** Deletes every analysis and prospect of the user; it cannot be undone. */
  purge(input: ForUser): Promise<PurgeResult>;
}

export const SettingsApi = moduleApi<SettingsApi>()("settings");
